(() => {
  document.querySelectorAll('[data-mobile-navigation]').forEach(header => {
    const toggle = header.querySelector('[data-mobile-menu-toggle]');
    const nav = header.querySelector('.pw-main-navigation');
    if (!toggle || !nav || header.dataset.mobileNavigationReady) return;
    header.dataset.mobileNavigationReady = 'true';
    const mobile = window.matchMedia('(max-width: 760px)');
    const setOpen = open => {
      nav.hidden = mobile.matches && !open;
      toggle.setAttribute('aria-expanded', String(mobile.matches && open));
    };
    const links = Array.from(nav.querySelectorAll('a[href]'), link => ({
      link, originalCurrent: link.getAttribute('aria-current')
    }));
    const pagePath = window.location.pathname.replace(/\/$/, '') || '/';
    const currentSection = pagePath === '/pages/learn-connected-is-not-the-same-as-braced'
      ? '/pages/learn' : pagePath;
    const sync = () => {
      setOpen(false);
      links.forEach(({ link, originalCurrent }) => {
        if (!mobile.matches) {
          if (originalCurrent === null) link.removeAttribute('aria-current');
          else link.setAttribute('aria-current', originalCurrent);
          return;
        }
        const destination = new URL(link.href, window.location.href);
        const destinationPath = destination.pathname.replace(/\/$/, '') || '/';
        if (destination.origin === window.location.origin && destinationPath === currentSection) {
          link.setAttribute('aria-current', pagePath === destinationPath ? 'page' : 'true');
        } else link.removeAttribute('aria-current');
      });
    };
    toggle.hidden = false;
    toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
    header.addEventListener('keydown', event => {
      if (event.key === 'Escape' && mobile.matches && toggle.getAttribute('aria-expanded') === 'true') {
        event.preventDefault(); setOpen(false); toggle.focus();
      }
    });
    nav.addEventListener('click', event => {
      if (mobile.matches && event.target.closest('a')) setOpen(false);
    });
    if (mobile.addEventListener) mobile.addEventListener('change', sync);
    else mobile.addListener(sync);
    sync();
  });
})();
